export default "__VITE_ASSET__DmE31hjm__"